<template>
  <SoSkeleton
    v-if="current.recentTenancyChange.isLoading"
    class="text-h4 pb-1"
    type="card"
  />
  <SoAlert
    v-if="
      current.recentTenancyChange.isError &&
      !current.recentTenancyChange.isLoading
    "
    class="mb-4"
    type="error"
  >
    {{ current.recentTenancyChange.errorMessage }}
  </SoAlert>
  <div
    v-else-if="
      current.recentTenancyChange.accountNumber &&
      !current.recentTenancyChange.isLoading
    "
  >
    <SoAlert v-if="hasIncompleteSteps" type="warning" class="mb-6"
      >The {{ isMovingIn ? "move in" : "move out" }} has been processed but some
      items are incomplete. Please add any relevant notes to the account that
      may aid completion at a later date.</SoAlert
    >
    <SoAlert
      v-else
      type="success"
      :title="
        isMovingIn
          ? 'Move in created successfully.'
          : 'Move out processed successfully.'
      "
      class="mb-6"
    />
    <p
      v-if="current.recentTenancyChange.accountNumber && isMovingIn"
      class="pb-5"
    >
      An account
      <span class="font-weight-bold">{{
        current.recentTenancyChange.accountNumber
      }}</span>
      has been created for {{ current.recentTenancyChange.email }}. You now need
      to create their
      <SoLink href="https://account.so.energy/admin/users/new"
        >online account</SoLink
      >.
    </p>
    <p
      v-else-if="current.recentTenancyChange.accountNumber && !isMovingIn"
      class="pb-5"
    >
      This account
      <span class="font-weight-bold">{{ current.accountNumber }}</span>
      will be closed. A new occupier account
      <span class="font-weight-bold">{{
        current.recentTenancyChange.accountNumber
      }}</span>
      has been created for this supply address.
    </p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoAlert from "@/components/SoAlert.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoLink from "@/components/SoLink.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoSkeleton,
      SoLink,
    },
    props: {
      isMovingIn: {
        type: Boolean,
        default: false,
      },
      hasIncompleteSteps: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
  })
</script>
